<template>
	<span>
		<span v-for="formElement in parent.formElements" :key="`tsps-${formElement.id}`">
			<template v-if="formElement.display">

				<!-- Multiplier -->
				<template v-if="formElement.type == 'multiplier'">
					<span class="badge badge-secondary mr-2">
						<template v-if="formElement.caption">
							{{ formElement.caption }}
						</template><template v-else>
							{{ formElement.name }}
						</template>: {{ formElement.value.length }}</span>
					<span v-for="(item, index) in formElement.value" :key="index">
						<span class="badge badge-secondary mr-2">{{ formElement.multicaption }} {{ index + 1 }}:</span>
						<TreatmentSessionProcedureSummary
							:treatmentsession="treatmentsession"
							:parentprocedure="parentprocedure"
							:parent="item"
							:key="`tsps-${index}`"
						/>
					</span>
				</template>

				<!-- Multiplier -->
				<template v-else-if="formElement.type == 'radiographs'">
					<template v-for="type in formElement.types" class="clear-left mb-3">
						<span class="badge badge-secondary mr-2" :key="type.name">{{type.caption}}: {{type.value.length}}</span>
					</template>
				</template>

				<!-- Eveything else -->
				<template v-else>
					<span class="badge badge-secondary mr-2">{{ getValueCaption(formElement) }}</span>
					<TreatmentSessionProcedureSummary
						:treatmentsession="treatmentsession"
						:parentprocedure="parentprocedure"
						:parent="formElement"
						:key="`tsps-${formElement.elementid}`"
						v-if="(('formElements' in formElement) && (formElement.formElements.length > 0))"
					/>
				</template>

			</template>
		</span>
	</span>
</template>

<script>
export default {
	name: "TreatmentSessionProcedureSummary",
	props: {
		treatmentsession: Object,
		parentprocedure: Object,
		parent: Object,
		toothmaplabels: {
			type: Array,
			default: () => [
				{},
				{
					usa: "1",
					fdi: "18",
					palmer: "8"
				},
				{
					usa: "2",
					fdi: "17",
					palmer: "7"
				},
				{
					usa: "3",
					fdi: "16",
					palmer: "6"
				},
				{
					usa: "4",
					fdi: "15",
					palmer: "5"
				},
				{
					usa: "5",
					fdi: "14",
					palmer: "4"
				},
				{
					usa: "6",
					fdi: "13",
					palmer: "3"
				},
				{
					usa: "7",
					fdi: "12",
					palmer: "2"
				},
				{
					usa: "8",
					fdi: "11",
					palmer: "1"
				},
				{
					usa: "9",
					fdi: "21",
					palmer: "1"
				},
				{
					usa: "10",
					fdi: "22",
					palmer: "2"
				},
				{
					usa: "11",
					fdi: "23",
					palmer: "3"
				},
				{
					usa: "12",
					fdi: "24",
					palmer: "4"
				},
				{
					usa: "13",
					fdi: "25",
					palmer: "5"
				},
				{
					usa: "14",
					fdi: "26",
					palmer: "6"
				},
				{
					usa: "15",
					fdi: "27",
					palmer: "7"
				},
				{
					usa: "16",
					fdi: "28",
					palmer: "8"
				},
				{
					usa: "17",
					fdi: "38",
					palmer: "8"
				},
				{
					usa: "18",
					fdi: "37",
					palmer: "7"
				},
				{
					usa: "19",
					fdi: "36",
					palmer: "6"
				},
				{
					usa: "20",
					fdi: "35",
					palmer: "5"
				},
				{
					usa: "21",
					fdi: "34",
					palmer: "4"
				},
				{
					usa: "22",
					fdi: "33",
					palmer: "3"
				},
				{
					usa: "23",
					fdi: "32",
					palmer: "2"
				},
				{
					usa: "24",
					fdi: "31",
					palmer: "1"
				},
				{
					usa: "25",
					fdi: "41",
					palmer: "1"
				},
				{
					usa: "26",
					fdi: "42",
					palmer: "2"
				},
				{
					usa: "27",
					fdi: "43",
					palmer: "3"
				},
				{
					usa: "28",
					fdi: "44",
					palmer: "4"
				},
				{
					usa: "29",
					fdi: "45",
					palmer: "5"
				},
				{
					usa: "30",
					fdi: "46",
					palmer: "6"
				},
				{
					usa: "31",
					fdi: "47",
					palmer: "7"
				},
				{
					usa: "32",
					fdi: "48",
					palmer: "8"
				}
			],
		},
		primarylabels: {
			type: Array,
			default: () => [
				{},
				{
					usa: "A",
					fdi: "55",
					palmer: "E"
				},
				{
					usa: "B",
					fdi: "54",
					palmer: "D"
				},
				{
					usa: "C",
					fdi: "53",
					palmer: "C"
				},
				{
					usa: "D",
					fdi: "52",
					palmer: "B"
				},
				{
					usa: "E",
					fdi: "51",
					palmer: "A"
				},
				{
					usa: "F",
					fdi: "61",
					palmer: "A"
				},
				{
					usa: "G",
					fdi: "62",
					palmer: "B"
				},
				{
					usa: "H",
					fdi: "63",
					palmer: "C"
				},
				{
					usa: "I",
					fdi: "64",
					palmer: "D"
				},
				{
					usa: "J",
					fdi: "65",
					palmer: "E"
				},
				{
					usa: "K",
					fdi: "75",
					palmer: "E"
				},
				{
					usa: "L",
					fdi: "74",
					palmer: "D"
				},
				{
					usa: "M",
					fdi: "73",
					palmer: "C"
				},
				{
					usa: "N",
					fdi: "72",
					palmer: "B"
				},
				{
					usa: "O",
					fdi: "71",
					palmer: "A"
				},
				{
					usa: "P",
					fdi: "81",
					palmer: "A"
				},
				{
					usa: "Q",
					fdi: "82",
					palmer: "B"
				},
				{
					usa: "R",
					fdi: "83",
					palmer: "C"
				},
				{
					usa: "S",
					fdi: "84",
					palmer: "D"
				},
				{
					usa: "T",
					fdi: "85",
					palmer: "E"
				}
			],
		}
	},
	computed: {
	},
	methods: {
		getValueCaption(formElement) {

			if(formElement.type == 'bool') {
				return formElement.value ? formElement.caption : null;
			}

			if(formElement.type == 'flag') {
				return formElement.value ? formElement.caption : null;
			}

			if(formElement.type == 'select') {
				let selectsummary = '';
				// Special rule for the "consent" selector
				if(formElement.caption && formElement.value){
					selectsummary = formElement.caption + ': ';
				}
				if(formElement.name != 'consent' /* not consent */ || formElement.value == 'none' /* is consent and value is none */) {
					for(let value of formElement.values) {
						if(value.value == formElement.value) {
							selectsummary += value.caption;
						}
					}
				}
				return selectsummary;
			}

			if(formElement.type == 'multiselect') {
				let showvalue = false;
				let html = '';
				if(formElement.caption){
					html = `${formElement.caption}:`;
				} else {
					html = `${formElement.name}:`;
				}
				for (let x in formElement.value) {
					if(formElement.value[x] == 1){
						showvalue = true;
						html += ` ${x}`;
					}
				}
				if(showvalue) {
					return html;
				}
			}

			if(formElement.type == 'text') {
				return `${formElement.caption}: ${formElement.value}`;
			}

			if(formElement.type == 'textarea') {
				return formElement.value ? formElement.caption : null;
			}

			if(formElement.type == 'toothmap') {
				let showvalue = false;
				let html = '';
				if(formElement.caption){
					html = `${formElement.caption}:`;
				} else {
					html = `${formElement.name}:`;
				}
				let pri, label;
				for (let x in formElement.value) {
					if(formElement.value[x] == 1) {
						showvalue = true;
						if(x.match(/pri_/)){
							pri = x.replace(/pri_/ , '');
							label = this.primarylabels[pri].fdi
						} else {
							label = this.toothmaplabels[x].fdi
						}
						html += ` ${label}`;
					}
				}
				if(showvalue) {
					return html;
				}
			}

			if(formElement.type == 'radiographs') {
				var qty = 0;
				for (var i=0; i < formElement.types.length; i++) {
					if(typeof(formElement.value[formElement.types[i].name + '_qty']) != 'undefined') {
						qty += parseInt(formElement.value[formElement.types[i].name + '_qty']);
					}
				}
				return `${qty} radiographs`;
			}

			if(formElement.type == 'multiplier') {
				if(formElement.value) {
					return `${formElement.caption}: ${formElement.value}`;
				}
			}

			return null;
		}
	}
};
</script>
